import { __awaiter } from 'tslib';
import '../../services/base/baseV3Service.js';
import '../../services/sgtService.js';
import { downloadAnalyticsReports } from '../../services/analyticsService.js';
import 'axios';
import '../../services/base/internalApiBaseService.js';
import '../../services/base/casaBaseService.js';
import '../../services/scanRequestsService.js';
import '../../services/base/analyticsV2BaseService.js';
import '../../services/db/insightsReportsDB.js';
import JSZip from 'jszip';
import { useState } from 'react';

var AnalyticsReportType;
(function (AnalyticsReportType) {
    //   Conversion = "conversion",
    AnalyticsReportType["SgtEngagement"] = "sgtEngagement";
    AnalyticsReportType["VirtualTourEngagement"] = "virtualTourEngagement";
    AnalyticsReportType["FloorPlanViews"] = "floorPlanViews";
    AnalyticsReportType["LayoutViews"] = "layoutViews";
    AnalyticsReportType["AmenityViews"] = "amenityViews";
    AnalyticsReportType["ReferralSources"] = "referralSources";
    AnalyticsReportType["ContentCreation"] = "contentCreation";
})(AnalyticsReportType || (AnalyticsReportType = {}));
const useDownloadAnalyticsReports = () => {
    const [finishedReports, setFinishedReports] = useState(null);
    const api = (analyticsDataParams) => __awaiter(void 0, void 0, void 0, function* () {
        const zip = new JSZip();
        setFinishedReports(null);
        downloadAnalyticsReports(analyticsDataParams, (fileName, status, content) => {
            setFinishedReports((prev) => (Object.assign(Object.assign({}, prev), { [fileName.replace(".csv", "")]: status === "success" })));
            if (status === "success") {
                zip.file(fileName, content, { base64: true });
            }
        })
            .catch(console.error)
            .finally(() => {
            if (Object.keys(zip.files).length > 0) {
                zip.generateAsync({ type: "blob" }).then(function (content) {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(content);
                    link.download = "peek-analytics.zip";
                    link.click();
                });
            }
            else {
                setFinishedReports({
                    // [AnalyticsReportType.Conversion]: false,
                    [AnalyticsReportType.SgtEngagement]: false,
                    [AnalyticsReportType.VirtualTourEngagement]: false,
                    [AnalyticsReportType.FloorPlanViews]: false,
                    [AnalyticsReportType.LayoutViews]: false,
                    [AnalyticsReportType.AmenityViews]: false,
                    [AnalyticsReportType.ReferralSources]: false,
                    [AnalyticsReportType.ContentCreation]: false,
                });
            }
        });
    });
    return [api, finishedReports];
};

export { AnalyticsReportType, useDownloadAnalyticsReports };
